import { hysteriFetch, wrappers } from 'hysterics';

const inventoryClientService = hysteriFetch('inventoryClientService', {
	timeout: {
		timeout: 1900
	},
	[wrappers.retry.contextKey]: {
		retries: 1
	}
});

export default async function fetchInventory({
	searchTerm,
	siteId,
	locale = 'en_US',
	widgetSearchServiceUri = '',
	configTypes
}) {
	const response = await inventoryClientService(
		`${widgetSearchServiceUri}/inventorySearch/${siteId}/${locale}?q=${encodeURIComponent(
			searchTerm
		)}
		&ct=${configTypes}`
	);
	return response;
}
